<template>
    <div>
        <span>{{ message }}</span>
    </div>
</template>

<script>
const getContactBatchActionText = (action) => {
    const actionTexts = {
        "add-tags": "etiket ekleme",
        "add-preferred-department": "tercih edilen departman ekleme",
        "add-preferred-agents": "tercih edilen agent ekleme",
        "set-owner": "sahip atama",
        "set-vip": "VIP durumu güncelleme",
        "add-contact-property": "kişi özelliği ekleme",
        "add-note": "not ekleme",
        "mark-as-answered": "cevaplanmış olarak işaretleme",
        "mark-as-read": "okunmuş olarak işaretleme",
    };
    return actionTexts[action] || "güncelleme";
};

export default {
    name: "ContactBatchUpdated",
    props: {
        activity: {
            type: Object,
            required: true
        }
    },
    computed: {
        message() {
            const action = this.$_.get(this.activity, 'payload.action');
            const actionText = getContactBatchActionText(action);
            return this.$t('notification.contactBatchUpdated', {
                actor: this.$_.get(this.activity, 'actorUser.name'),
                contactCount: this.$_.get(this.activity, 'payload.contactCount', 0),
                action: actionText
            });
        }
    }
};
</script>


